import { ReactNode } from 'react';

import {
  InteractiveSequenceDropItem,
  InteractiveSequenceDropItemTarget,
  InteractiveSequenceDropItemZone,
  InteractiveSequenceDropLabel,
} from './interactive-sequence-drop.style';

const InteractiveSequenceDropDisplay = (props: {
  label?: string;
  labelLength?: number | null;
  labelBorder?: boolean | null;
  isCorrect?: boolean;
  baseColour?: string;
  children?: ReactNode;
  width?: number;
  height?: number;
  'data-selector'?: string;
}) => {
  const {
    label,
    labelLength,
    labelBorder,
    children,
    isCorrect,
    baseColour,
    width,
    height,
    'data-selector': dataSelector,
  } = props;
  return (
    <InteractiveSequenceDropItem
      $labelLength={labelLength}
      $labelBorder={labelBorder}
      $baseColour={baseColour}
      data-selector={dataSelector}
    >
      <InteractiveSequenceDropItemTarget
        $isOver={false}
        $canDrop={false}
        $hasDropped={!!children}
        $isCorrect={isCorrect}
        $width={width}
        $height={height}
      >
        {children ? children : <InteractiveSequenceDropItemZone />}
      </InteractiveSequenceDropItemTarget>
      <InteractiveSequenceDropLabel>{label}</InteractiveSequenceDropLabel>
    </InteractiveSequenceDropItem>
  );
};

export default InteractiveSequenceDropDisplay;
